import { render, staticRenderFns } from "./GoodsPublishStep3.vue?vue&type=template&id=6fc9d987&scoped=true"
import script from "./GoodsPublishStep3.vue?vue&type=script&lang=js"
export * from "./GoodsPublishStep3.vue?vue&type=script&lang=js"
import style0 from "./GoodsPublishStep3.vue?vue&type=style&index=0&id=6fc9d987&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9d987",
  null
  
)

export default component.exports